async function initSampleButtonListeners() {
    let sampleButtons = document.querySelectorAll('.add-sample-button');

    sampleButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            updateCart(e.target);
        });
    });
}

async function getCartContent() {
    let cartContents = await fetch(window.Shopify.routes.root + "cart.js")
        .then(response => {return response.json();})
        .catch((error) => {
            console.error('Error:', error);
        });
    return cartContents;
}

async function updateCart(sampleButton) {
    let sampleVariant = sampleButton.getAttribute('data-sample-variant-id');

    if (sampleVariant == null || sampleVariant == '') {
        return;
    }

    let cartContents = await getCartContent();
    let sampleVariantCount = 1;

    if (cartContents && cartContents.item_count > 0) {
        let cartItems = cartContents.items;

        cartItems.forEach(item => {
            if (item.variant_id == sampleVariant) {
                sampleVariantCount += item.quantity;
            }
        });
    }

    if (sampleVariantCount > 1) {
        await postUpdateCartCall(sampleVariant, sampleVariantCount);
    } else {
        postAddToCartCall(sampleVariant, sampleVariantCount);
    }
}

async function postAddToCartCall(sampleVariant, sampleVariantCount) {
    let formData = {
        'items': [{
            'id': parseInt(sampleVariant),
            'quantity': sampleVariantCount
        }]
    };

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(async (response) => {

        let responseJson = await response.json();

        //rebuild cart
        await rebuildCart();

        // show message
        document.documentElement.dispatchEvent(
            new CustomEvent("cart-notification:show", {
                bubbles: true,
                detail: {
                    status: "success",
                },
            })
        );
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

async function postUpdateCartCall(sampleVariantId, sampleVariantCount) {
    let updates = {};
    updates[sampleVariantId] = sampleVariantCount;

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({updates})
    })
    .then(async (response) => {
        let responseJson = await response.json();
        //refresh cart
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                    cart: responseJson,
                },
            })
        );
        // show message
        document.documentElement.dispatchEvent(
            new CustomEvent("cart-notification:show", {
                bubbles: true,
                detail: {
                    status: "success",
                },
            })
        );
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

async function rebuildCart() {
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (response2) => {
            const cartContent = await response2.json();

            document.documentElement.dispatchEvent(
                new CustomEvent("cart:updated", {
                    bubbles: true,
                    detail: {
                        cart: cartContent,
                    },
                })
            );

            document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        cart: cartContent,
                        openMiniCart:
                            window.themeVariables.settings.cartType === "drawer" &&
                            this.closest(".drawer") === null,
                    },
                })
            );
        }
    );
}

function initSampleVariantLogic() {
    let swatchSampleWrapperElements = document.querySelectorAll('.swatch-sample-wrapper');

    swatchSampleWrapperElements.forEach(swatchSampleEl => {
        updateSampleButtonVariant(swatchSampleEl);

        swatchSampleEl.addEventListener('change', function (e) {
            let swatchSampleWrapper = e.target.closest('.swatch-sample-wrapper');
            if (swatchSampleWrapper != null) {
                updateSampleButtonVariant(swatchSampleWrapper);
            }
        });
    });
}

function updateSampleButtonVariant(swatchSampleEl) {
    let selectedColorElement = swatchSampleEl.querySelector('.color-swatch__radio:checked');
    let sampleButtonElement = swatchSampleEl.querySelector('.add-sample-button');

    if (sampleButtonElement == null) {
        return;
    }

    if (selectedColorElement == null) {
        sampleButtonElement.classList.add('hidden');
        return;
    }

    let selectedColor = selectedColorElement.value;
    let selectedColorInput = swatchSampleEl.querySelector(`[name="color_option[${selectedColor}]"]`);
    let isB2BCustomer = sampleButtonElement.getAttribute('data-customer-is-b2b');
    let customerAttribute = isB2BCustomer == 'true' ? 'data-b2b-sample-variant' : 'data-retail-sample-variant';
    let selectedColorVariantId = selectedColorInput.getAttribute(customerAttribute);

    // if selected color option has no sample, return any other color sample variant for customer type
    if (selectedColorVariantId == null || selectedColorVariantId == '') {
        sampleButtonElement.classList.add('hidden');
        return;
    }

    sampleButtonElement.classList.remove('hidden');
    sampleButtonElement.setAttribute('data-sample-variant-id', selectedColorVariantId);
}

function getFirstAvailableSample(swatchSampleEl, customerAttribute) {
    let allSelectedColorInputs = swatchSampleEl.querySelectorAll(`[name*="color_option"]`);
    for (let index = 0; index < allSelectedColorInputs.length; index++) {
        let variantId = allSelectedColorInputs[index].getAttribute(customerAttribute);
        if (variantId != null) {
            return variantId;
        }
    }
    return null;
}

document.addEventListener('facet:product-list-finished-loading', function() {
    initSampleButtonListeners();
    initSampleVariantLogic();
});

document.addEventListener('klevu-recs-loaded', function() {
    initSampleButtonListeners();
    initSampleVariantLogic();
});
